import React , { useRef, useState } from 'react'
import {InsertPhoto, VisDiv, HorizontalSwipeSanity, InsertPhotoSanity, Loading} from './'
import { useStateContext } from '../context/StateContext'
import useNetworkStatus from '../hooks/useNetworkStatus'
import { clientUser, facilityClient } from '../lib/userPermissions'
import ModalContent from './ModalContent';
import { urlFor } from '../lib/client';
import { fromBase64ToSanity, objectIsObject } from '../lib/utils'
import { useUploadPhoto } from '../hooks/mutations'
import { AiFillCamera } from 'react-icons/ai';
import { optimizeImage } from '../hooks/imageOptimizer';
import { successAlert } from '../lib/utils'
import { keyId } from '../lib/utils'
import { MdPowerSettingsNew, MdNavigateBefore, MdNavigateNext } from "react-icons/md";
import Swal from 'sweetalert2'
import { useDeletePhoto } from '../hooks/mutations'
import { AiTwotoneDelete } from 'react-icons/ai';
import { errorAlert } from '../lib/utils'



const PhotosBeforeAfter = ({doc, saveFn, updateDoc, hideAfterPictureIcon, enableDelete}) => { 
    const { LDB, client, sUser } = useStateContext();
    const networkStatus = useNetworkStatus()
    const testing = false

    const {mutate: deletePhotoAsset} = useDeletePhoto({
        onError:()=>{
            errorAlert("ELIMINAZIONE PHOTO NON RIUSCITA")
          } 
    })

    const {mutate: uploadPhotoAsset} = useUploadPhoto({
        onError:()=>{
            errorAlert("UPLOAD FOTO NON RIUSCITO")
          } 
    })

    const archivePhoto = (data) => {
        const images = doc?.images ? doc?.images : []
        const updatedDoc = {...doc, images:[...images?.filter?.((x=>x?._id !== data?._id)), data]}
        console.log("archive asset and photo", data,"UPDATED DOC",updatedDoc)
        saveFn(updatedDoc)
    }

    const testFunction = () => {
        console.log(doc)
    }

    const saveAfterPhoto = (data) => {
        console.log("save after photo", data)
        //const sanityPicDoc = data?.sanityImage || base64Image
            
        const images = doc?.images ? doc?.images : []
        const findDoc = (!Array.isArray(images) ? undefined : images?.find?.((x=>x?._id == data?.beforeAfterPhotoId))) ? images?.find?.((x=>x?._id == data?.beforeAfterPhotoId)) : {} 
        console.log("ndksndjend find doc", findDoc)
        const updatedImage = {
            ...findDoc, 
            after: data}  
        const updatedDoc = {...doc, images:[...images?.filter?.((x=>x?._id !== data?.beforeAfterPhotoId)), updatedImage]}
        saveFn(updatedDoc)
    }
/*     const saveAfterPhoto = (data) => {
        const images = doc?.images ? doc?.images : []
        const findDoc = (!Array.isArray(images) ? undefined : images?.find?.((x=>x?._id == data?.beforeAfterPhotoId))) ? images?.find?.((x=>x?._id == data?.beforeAfterPhotoId)) : {} 
        const afterBase64Image = {
            ...findDoc, 
            after: {
                base64Image: data?.base64Image, 
                beforeOrAfter:"after", 
                beforeAfterPhotoId: data?.beforeAfterPhotoId, 
                postedOn: Date.now(), 
                postedBy: { _type: 'postedBy', _ref: sUser._id, _key: keyId() },
            }
        }  
        const updatedDoc = {...doc, images:[...images?.filter?.((x=>x?._id !== data?.beforeAfterPhotoId)), afterBase64Image]}
        saveFn(updatedDoc)
    } */

/*     const saveDoc = (data) => {
        console.log("SAVE AFTER PHOTO", data, "DOC", doc)
        if(!networkStatus) {
            const images = doc?.images ? doc?.images : []
            const findDoc = (!Array.isArray(images) ? undefined : images?.find?.((x=>x?._id == data?.beforeAfterPhotoId))) ? images?.find?.((x=>x?._id == data?.beforeAfterPhotoId)) : {} 
            const afterBase64Image = {
                ...findDoc, 
                after: {
                    base64Image: data?.base64Image, 
                    beforeOrAfter:"after", 
                    beforeAfterPhotoId: data?.beforeAfterPhotoId, 
                    postedOn: Date.now(), 
                    postedBy: { _type: 'postedBy', _ref: sUser._id, _key: keyId() },
                }
            }  
            const updatedDoc = {...doc, images:[...images?.filter?.((x=>x?._id !== data?.beforeAfterPhotoId)), afterBase64Image]}
            saveFn(updatedDoc)
        }
        else {
            uploadPhotoAsset(data?.sanityImage,{
                onSuccess:(asset)=>{
                const sanityPicDoc = {
                    _type: 'image',
                    _key: keyId(),
                    asset: {
                        _type: 'reference',
                        _ref: asset?._id,
                        _key: keyId()
                      },
                  }
                
                const images = doc?.images ? doc?.images : []
                const findDoc = (!Array.isArray(images) ? undefined : images?.find?.((x=>x?._id == data?.beforeAfterPhotoId))) ? images?.find?.((x=>x?._id == data?.beforeAfterPhotoId)) : {} 
                console.log("ndksndjend find doc", findDoc)
                const updatedImage = {
                    ...findDoc, 
                    after: {
                        sanityImage: sanityPicDoc, 
                        beforeAfterPhotoId: data?.beforeAfterPhotoId,
                        beforeOrAfter:"after", 
                        postedOn: Date.now(), 
                        postedBy: { _type: 'postedBy', _ref: sUser._id, _key: keyId() },}}  
                const updatedDoc = {...doc, images:[...images?.filter?.((x=>x?._id !== data?.beforeAfterPhotoId)), updatedImage]}
                saveFn(updatedDoc)
              }
            })
        }        
    } */

/*     const images = () => {
        if (!doc?.images) return []
        return doc?.images
    } */

    return(
      <VisDiv className='new-device-container-top' style={{marginTop:"5px", marginBottom:"5px",}}>
{/*             <VisDiv rules={[false]} className='title-with-side-icons'>
                <VisDiv rules={[networkStatus, clientUser(sUser), facilityClient(client, sUser), clientUser(sUser)]}>
                    <InsertPhotoSanity
                        saveSanityFn={InsertPhoto}
                    /> 
                </VisDiv>
                <VisDiv rules={[!networkStatus, clientUser(sUser), facilityClient(client, sUser), clientUser(sUser)]}>
                    <InsertPhoto
                        saveFn={InsertPhotoSanity}
                    />
                </VisDiv>
                <VisDiv rules={[!facilityClient(client, sUser) || !clientUser(sUser)]}></VisDiv>
                 <div></div>
            </VisDiv> */}
            
            <BeforeAfterSwipe
                hideAfterPictureIcon = {hideAfterPictureIcon}
                images={doc?.images ? doc?.images : []}
                saveFn={saveAfterPhoto}
                //saveFn={saveDoc}
                updateDoc={archivePhoto}
                enableDelete = {enableDelete}
            />
            <VisDiv rules={[testing]}>
                <button onClick={testFunction}> test before after </button>
            </VisDiv>

            <VisDiv rules={[doc?.image?.length < 1 || !doc?.image, false]}>
                <div className='horizontal-swipe-box' style={{ border: "2px dashed", borderRadius:"10px", height: "120px", width:"120px", display:"flex", alignItems:"center" }}>
                    {LDB("misc", "noPhotos")}
                </div>
            </VisDiv>
      </VisDiv>
    )
}

export const BeforeAfterSwipe = ({images, updateDoc, enableDelete, hideAfterPictureIcon, offlineImages, saveFn = () =>{}}) => {
    const networkStatus = useNetworkStatus()
    const{modalOpen, setModalOpen, setModalContent} = useStateContext();

    const modalContent = (item, index, picturesForSlider) =>    
    <ModalContent 
        setOpenModal={setModalOpen}
        setModalContent={setModalContent}
        title={"Picture Modal"}
        body={`Picture ${index}`}
        continueTo={()=>{}}
        picturesForSlider= {picturesForSlider}
        beforePicture={item}
        initialIndex = {index}
    />
    
    return (
        <div className='horizontal-swipe-wrapper'>
            {images?.filter?.(x=>x?.before)?.map?.((item, index, images) => { 
                const key = index
                // Handle both online and offline images
                const onlineImage = item?.before?.sanityImage
                const offlineImage = item?.before?.base64Image
                
                // For offline images, ensure we have the proper structure
                const beforePhoto = onlineImage || (offlineImage?.src ? offlineImage : null)

                // Skip rendering if we don't have a valid image
                if (!beforePhoto) {
                    console.log("Invalid image data:", { onlineImage, offlineImage, item })
                    return null
                }

                const onPicClick = () => {
                    setModalContent(modalContent(beforePhoto, index, images))
                    setModalOpen(!modalOpen);
                    console.log("modal clicked", beforePhoto, images)
                }
                return(
                    <div key={key} onClick={()=>onPicClick()} className='horizontal-swipe-box'>
                        <VisDiv rules={[false]}><button onClick={(e)=>{ e.stopPropagation(); console.log("jhwcdnbjhdbc", item)}}>Test Pic</button></VisDiv>
                        <Photo updateDoc = {updateDoc} enableDelete={enableDelete} hideAfterPictureIcon = {hideAfterPictureIcon} photo={item} saveFn={saveFn}/>
                    </div>
                )
            })}
        </div>
    )
}

export const Photo = ({enableDelete, photo, updateDoc = () => {}, hideAfterPictureIcon, saveFn = ()=>{}}) => {
    const networkStatus = useNetworkStatus()
    const {sUser } = useStateContext();
 
    
    // Validate before photo data
    // Handle both online (Sanity) and offline (base64) images
    const beforePhotoOffline = photo?.before?.base64Image
    const beforePhotoOnline = photo?.before?.sanityImage
    const beforePhoto = beforePhotoOnline ? beforePhotoOnline : beforePhotoOffline

    // Ensure we have a valid Sanity asset reference before calling urlFor
    const isValidSanityAsset = (asset) => {
        return asset && 
               typeof asset === 'object' && 
               asset.asset && 
               asset.asset._ref && 
               typeof asset.asset._ref === 'string' && 
               asset.asset._ref.length > 0;
    }

    // Generate URL for before photo with validation
    const beforePhotoUrl = beforePhotoOnline && isValidSanityAsset(beforePhotoOnline)
        ? urlFor(beforePhotoOnline).width(1020).height(1020)?.url()
        : beforePhotoOffline?.src // base64Image.src from the document

    const [togglePhoto, setTogglePhoto] = useState("both")

    // Validate after photo data
    const afterPhotoOffline = photo?.after?.base64Image
    const afterPhotoOnline = photo?.after?.sanityImage
    const afterPhoto = afterPhotoOnline ? afterPhotoOnline : afterPhotoOffline

    // Generate URL for after photo with validation
    const afterPhotoUrl = afterPhotoOnline && isValidSanityAsset(afterPhotoOnline)
        ? urlFor(afterPhotoOnline).width(1020).height(1020)?.url()
        : afterPhotoOffline?.src // base64Image.src from the document

    // Debug log for image validation
    if (!beforePhotoUrl) {
        console.log("Image validation failed:", {
            hasOfflineImage: !!beforePhotoOffline?.src,
            hasOnlineImage: !!beforePhotoOnline,
            offlineImageSrc: beforePhotoOffline?.src?.substring(0, 50) + '...',
        })
    }

    // Validate photo structure
    if (!photo?.before) {
        console.log("Missing photo.before structure:", photo)
        return null
    }

    // For offline images, ensure we have base64Image with src
    if (!beforePhotoOnline && beforePhotoOffline) {
        if (!beforePhotoOffline.src) {
            console.log("Offline image missing src:", beforePhotoOffline)
            return null
        }
        console.log("Using offline image src:", beforePhotoOffline.src)
    }

    // For online images, ensure we have valid Sanity asset
    if (beforePhotoOnline && !isValidSanityAsset(beforePhotoOnline)) {
        console.log("Invalid Sanity asset:", beforePhotoOnline)
        return null
    }

    const{modalOpen, setModalOpen, setModalContent} = useStateContext();

    const deletePic = (e) => {
        e?.stopPropagation()
        const warningText = () => {
            if(togglePhoto == "after" && photo?.after) return `Stai eliminando solo l'immagine "Dopo"`
            return `Stai eliminando tutte le immagini presenti, prima e dopo`
        }

        const archivedPicturesArray = photo?.archivedPictures?.length > 0 ? photo?.archivedPictures : []
        const archiveImages = () => {
            if(togglePhoto == "after" && photo?.after) {
                const docWithNoAfterPicture = {
                    _id: photo?._id,
                    _key: photo?._key,
                    _type: "beforeAfterPhoto",
                    before: photo?.before,
                    archivedPictures: [...archivedPicturesArray, {...objectIsObject(photo?.after) ? photo?.after : {}, base64Image: undefined}]
                }
                updateDoc(docWithNoAfterPicture)
            } else {
                const docWithNoBeforeAndAfter = {
                    _id: photo?._id,
                    _key: photo?._key,
                    _type: "beforeAfterPhoto",
                    archivedPictures: [...archivedPicturesArray, {...objectIsObject(photo?.after) ? photo?.after : {}, base64Image: undefined}, {...objectIsObject(photo?.befor) ? photo?.before : {}, base64Image: undefined}]
                }
                updateDoc(docWithNoBeforeAndAfter)
            }
        }

        const alert = () => {
            Swal.fire({
                title:  "Eliminare Immagini?",
                text: warningText(),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'red',
                cancelButtonColor: 'grey',
                confirmButtonText: "ELIMINA",
                cancelButtonText: "ANNULLA"
              }).then((result) => {
                if (result.isConfirmed) {
                    archiveImages()
                }
              })
        }
      
        alert()
    }
    const savePhotoSanity = (asset) => {
       
        const doc = {
            sanityImage: asset, 
            beforeOrAfter:"after", 
            beforeAfterPhotoId: photo?._id,
            postedOn: Date.now(), 
            postedBy: { _type: 'postedBy', _ref: sUser._id, _key: keyId()},
        }
        console.log("ASSET SANITY", asset, doc)
        saveFn(doc)

    }
    const savePhoto = async (data) => {
        try {
            console.log("SAVE AFTER PHOTO alreufh", data, "PHOTO", photo, "NETWORK", networkStatus)
            
            // The data is already an optimized base64Doc object from InsertPhoto.jsx
            saveFn({
                base64Image: data,
                beforeOrAfter: "after",
                beforeAfterPhotoId: photo?._id,
                postedOn: Date.now(),
                postedBy: { _type: 'postedBy', _ref: sUser._id, _key: keyId()},
            })
        } catch (error) {
            console.error("Error optimizing after photo:", error);
            errorAlert("Errore durante il salvataggio dell'immagine");
        }
    }

/*     const saveAfterPhoto = (data) => {
        if(!networkStatus) { 
            console.log("SAVE AFTER PHOTO", data, "PHOTO", photo, "NETWORK", networkStatus)
            saveFn({
                base64Image: data, 
                beforeOrAfter:"after",  
                beforeAfterPhotoId: photo?._id,
                postedOn: Date.now(), 
                postedBy: { _type: 'postedBy', _ref: sUser._id, _key: keyId()},
            }) 
        } else {
            console.log("SAVE AFTER PHOTO", data, "PHOTO", photo, "NETWORK", networkStatus)
            fromBase64ToSanity(data)
            ?.then((asset)=>{
                console.log("ASSET SANITY", asset)
                const doc = {
                    sanityImage: asset, 
                    beforeOrAfter:"after", 
                    beforeAfterPhotoId: photo?._id,
                    postedOn: Date.now(), 
                    postedBy: { _type: 'postedBy', _ref: sUser._id, _key: keyId()},
                }
                saveFn(doc)
            })
        }
    } */

/*     const modalContent = (item) =>    
    <ModalContent 
        setOpenModal={setModalOpen}
        setModalContent={setModalContent}
        title={"Take Picture Modal"}
        beforePicture = {item}
        savePictureBase64 = {saveAfterPhoto}
        continueTo={()=>{}}
        takePicture= {true}
    /> */

/*     const takePic = (e) => {
        e?.stopPropagation()
        setModalContent(modalContent(beforePhoto))
        setModalOpen(!modalOpen);
    } */

    const rotation = () => {
        if(togglePhoto=="both") return ""
        if(togglePhoto=="before") return "rotate-left"
        if(togglePhoto=="after") return "rotate-right"
    }

    // Only render if we have valid photo URL
    if (!beforePhotoUrl) {
        console.log("No beforePhotoUrl found with:", { beforePhotoOnline, beforePhotoOffline })
        return;
    }

    if(!beforePhotoUrl) return<Loading />

    return (
        <div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>  
            <VisDiv rules={[clientUser(sUser), enableDelete]} className='edit-button-container' style={{marginBottom: "-15px", zIndex: 100}}>
                <button type='button' className='round-back-button' style={{backgroundColor:"red"}} onClick={(e) => deletePic(e)}>
                    <AiTwotoneDelete             
                    size={20}
                    color={"white"}/>
                </button>
            </VisDiv>

            <VisDiv rules={[!afterPhotoUrl, beforePhoto]}>
                <img 
                    src={beforePhotoUrl}
                    style={{width:"120px", height:"120px"}}
                    className="product-image"
                />
            </VisDiv>
            <VisDiv rules={[afterPhotoUrl, beforePhoto]}>
               <VisDiv rules={[togglePhoto == "both"]} style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
                    <VisDiv>
                        <img 
                            src={beforePhotoUrl}
                            style={{width:"120px", height:"120px"}}
                            className="product-image"
                        />
                    </VisDiv>
                    <VisDiv className="diagonal-crop-image">
                        <img 
                            src={afterPhotoUrl}
                            style={{width:"120px", height:"120px"}}
                            className="product-image"
                        />
                    </VisDiv>
                </VisDiv>
                <VisDiv rules={[togglePhoto == "before"]} >
                    <img 
                        src={beforePhotoUrl}
                        style={{width:"120px", height:"120px"}}
                        className="product-image"
                    />  
                </VisDiv>
                <VisDiv rules={[togglePhoto == "after"]} >
                    <img 
                        src={afterPhotoUrl}
                        style={{width:"120px", height:"120px"}}
                        className="product-image"
                    />  
                </VisDiv>
                <VisDiv onClick={(e)=>{e.stopPropagation()}} style={{display:"flex", justifyContent:"space-between", marginTop:"5px"}}>
                    <VisDiv onClick={((e)=>{e.stopPropagation(); setTogglePhoto("before")})}>
                        < MdNavigateBefore  fontSize={27}/>
                    </VisDiv>
                    <VisDiv className={rotation()} onClick={((e)=>{e.stopPropagation(); setTogglePhoto("both")})}>
                        <MdPowerSettingsNew  fontSize={27}/>
                    </VisDiv>
                    <VisDiv onClick={((e)=>{e.stopPropagation(); setTogglePhoto("after")})}>
                        <MdNavigateNext  fontSize={27}/>
                    </VisDiv>
                </VisDiv>
            </VisDiv>
            <VisDiv onClick={(e)=>{e.stopPropagation()} } rules={[networkStatus, clientUser(sUser), !afterPhoto, !hideAfterPictureIcon]} style={{marginTop:"-20px", zIndex:"1000"}}>
                <InsertPhotoSanity
                    saveSanityFn={savePhotoSanity}
                /> 
            </VisDiv>
            <VisDiv onClick={(e)=>e.stopPropagation()} rules={[!networkStatus, clientUser(sUser), !afterPhoto, !hideAfterPictureIcon]} style={{marginTop:"-20px", zIndex:"1000"}}>
                <InsertPhoto
                    saveFn={savePhoto}
                />
            </VisDiv>
        </div>
    )
}

export default PhotosBeforeAfter
